/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2023-03-24 13:50:36
 * @LastEditors: changfeng
 * @LastEditTime: 2023-05-04 14:09:03
 */
export default {
  'campaign.title': '推广系列',
  'campaign.create.new': '新建系列',
  'campaign.select': '从已有中选择',
  'campaign.select.exiting': '选择已有推广系列',
  'campaign.name': '推广系列名称',
  'campaign.set campaign budget': '设置推广系列预算',
  'campaign.set campaign budget on': '推广系列预算优化',

  'campaign.create success': '推广系列创建成功',
  'campaign.budget.day': '日预算',
  'campaign.budget.total': '总预算',
  'campaign.budget.placeholder': '50.00以上',

  'campaign.form.message.adAccount': '请选择广告账户',
  'campaign.form.message.please choose campaign': '请选择推广系列',
  'campaign.form.message.budget': '请输入不小于50的数字',
};
